import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { HeroContent, HeroImage, HeroMain, HeroRow, LogoContainer } from './index.style'
import Container from '@components/Container'
import RichText from '@components/RichText'
import Spacer from '@components/Spacer'
import { Caption } from '@components/TextStyles'
import { GatsbyImage } from 'gatsby-plugin-image'
import Logo from '@svgs/Logo';
import AnimateSlideIn from '@components/animation/AnimateSlideIn'

const Hero = ({ name, title, image, bgColor, tColor, overlay = true }) => {

  return (
    <HeroMain bgColor={bgColor} tColor={tColor}>
      {image && (
          <HeroImage>
            <GatsbyImage
              image={image.gatsbyImageData}
              alt={image.description}
            />
          </HeroImage>
      )}
      <Container className="content">
      <Spacer size={[120, 280]} />
        <RichText
          content={title}
          paragraphSize="heading2Serif"
          maxWidth={12}
          as="h1"
        />
        <Spacer size={60} />
      </Container>
    </HeroMain>
  )
}

Hero.propTypes = {
  data: PropTypes.object,
}

export default Hero
